var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 11.25l6.25 40L5 47.5l-2.5-8.75 5-10L21.25 15l7.5-3.75h10z",
    fill: "#3169BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 41.25L5 47.5l-2.5-8.75 10-5 5 7.5z",
    fill: "#6EA7F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51.25l-12.5-27.5 6.25-12.5 6.25 40zM28.75 11.25L25 20 12.5 33.75l-10 5 5-10L21.25 15l7.5-3.75z",
    fill: "#3184F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51.25l-27.5-10 15-17.5L45 51.25z",
    fill: "#6EA7F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 23.75l-15 17.5-5-7.5L25 20l7.5 3.75zM77.5 56.25L75 65l-38.75 2.5L40 28.75l10-1.25 10 5L72.5 45l5 11.25z",
    fill: "#10489D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 41.25L36.25 67.5 40 28.75l7.5 12.5z",
    fill: "#3169BE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 56.25L67.5 50 55 37.5l-5-10 10 5L72.5 45l5 11.25zM75 65l-38.75 2.5 26.25-10L75 65z",
    fill: "#6EA7F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 50l-5 7.5-15-16.25L55 37.5 67.5 50z",
    fill: "#3169BE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 57.5l-26.25 10L47.5 41.25l15 16.25z",
    fill: "#3184F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 61.25l-.39.195A11.206 11.206 0 0025 68.75a11.205 11.205 0 00-5.86-7.305l-.39-.195.39-.195A11.206 11.206 0 0025 53.75a11.205 11.205 0 005.86 7.305l.39.195z",
    fill: "#FDD430"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 53.75h2.5v2.5h-2.5v-2.5z",
    fill: "#FD8B83"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72.5h2.5V75H30v-2.5z",
    fill: "#F2105A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10 63.75h2.5v2.5H10v-2.5z",
    fill: "#FD82AB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 72.5H15V75h-2.5v-2.5z",
    fill: "#744634"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60 13.75l-.39.195a11.206 11.206 0 00-5.86 7.305 11.205 11.205 0 00-5.86-7.305l-.39-.195.39-.195a11.206 11.206 0 005.86-7.305 11.205 11.205 0 005.86 7.305l.39.195z",
    fill: "#FDD430"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.75 23.75a7.906 7.906 0 00-5 5 7.906 7.906 0 00-5-5 7.906 7.906 0 005-5 7.906 7.906 0 005 5z",
    fill: "#FFFD38"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 12.5H70V15h-2.5v-2.5z",
    fill: "#FFFE94"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 17.5h2.5V20h-2.5v-2.5z",
    fill: "#10489D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.75 7.5h2.5V10h-2.5V7.5z",
    fill: "#FD8B83"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 28.75h2.5v2.5h-2.5v-2.5z",
    fill: "#F2105A"
  })));
}

export default __webpack_public_path__ + "./fonts/diamond.5776b71cfc2b60190d381d6f259ff84e.svg";
export { SvgDiamond as ReactComponent };